import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { getFeeds } from "../../actions/dataActions";
import Item from "./item";
import "./style.scss";

const Feeds = () => {
  const token = useSelector((state) => state.LoginSM.token);
  const [page, setpage] = useState(2);
  const [hasMore, sethasMore] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const initFeeds = async () => {
      await getFeeds(1, token).then((data) => {
        const results = mappingDataActive(data.data.results);

        sethasMore(data.data.next);
        setItems(results);
      });
    };

    initFeeds();
  }, []);

  const mappingDataActive = (data) => {
    const listFeature = [
      "quiz",
      "survey",
      "news",
      "announcement",
      "polling",
      "event",
    ];

    let results = [];

    data.forEach((item) => {
      if (item.is_news) {
        results.push(item);
      }

      if (item.object !== null) {
        if (listFeature.includes(item.object.type)) {
          results.push(item);
        }
      }
    });

    return results;
  };

  const fetchData = async () => {
    if (hasMore) {
      const data = await getFeeds(page, token).then((data) => data.data);
      const results = mappingDataActive(data.results);

      sethasMore(data.next);
      setItems([...items, ...results]);
      setpage(page + 1);
    }
  };

  const loader = <div className="text-align-center">Loading ...</div>;

  return (
    <>
      <InfiniteScroll
        dataLength={items.length}
        next={fetchData}
        hasMore={hasMore}
        loader={loader}
      >
        {items.map((item) => {
          return <Item data={item} key={item.id} />;
        })}
      </InfiniteScroll>
    </>
  );
};

export default Feeds;
